require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};



//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/~/core-js/library/fn/object/create.js
// module id = 2470
// module chunks = 121